<div class="stage-container arrow-right eip-mt-20 eip-ml-0 eip-mr-0 eip-pxy-20 reset-row">
  <form>
      <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12" *ngIf="scheduleTypeList?.length > 0">
              <section class="example-section" style="display: flex;" [formGroup]="DCI_Type">
                  <p class="fs-16 ff-3"> Schedule Type :</p>
                  <div *ngFor="let item of scheduleTypeList">
                      <mat-checkbox class="eip-ml-10" (change)='onScheduleTypeChange($event,item)' [checked]="true">{{item.deD_Short_Description}}</mat-checkbox>
                  </div>
              </section>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12" *ngIf="docTypeList?.length > 0">
              <section class="example-section d-flex" [formGroup]="DocType">
                  <p class="fs-16 ff-3">DWG / DOC :</p>
                  <div *ngFor="let item of docTypeList">
                    <mat-checkbox class="eip-ml-10" [checked]="selectedDocTypes.includes(item.deD_Short_Description)" (change)="onDocTypeChange($event, item)">
                      {{ item.deD_Short_Description }}
                    </mat-checkbox>
                  </div>                  
              </section>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12" *ngIf="ccnTypeList?.length > 0">
              <section class="example-section" style="display: flex;" [formGroup]="CCNType">
                  <p class="fs-16 ff-3"> CCN Type :</p>
                  <div *ngFor="let item of ccnTypeList">
                      <mat-checkbox class="eip-ml-10" (change)='onCCNTypeChange($event,item)'>{{item.deD_Short_Description}}</mat-checkbox>
                  </div>
              </section>
          </div>
      </div>
      <div class="row eip-mt-10">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-button-toggle-group #group="matButtonToggleGroup" class="sche-semiauto" aria-label="tranType" [value]='tranType' (change)="tranTypeChange($event.value)">
                  <mat-button-toggle value="count">No of Drawings</mat-button-toggle>
                  <mat-button-toggle value="sum">A1 Equivalent</mat-button-toggle>
              </mat-button-toggle-group>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-button-toggle-group #group="matButtonToggleGroup" class="sche-semiauto" aria-label="isStatic" [value]='isStatic' (change)="isStaticChange($event.value)">
                  <mat-button-toggle value="0">Dynamic</mat-button-toggle>
                  <mat-button-toggle value="1">Static</mat-button-toggle>
              </mat-button-toggle-group>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <EIPDateRangePicker id="eipdatePickerRequiredOn" WaterMark="From - To" setId="eipARDatePickerPeriod" [valueStart]=start [valueEnd]=end (selectedStartDate)='getStartDateValue($event)' (selectedEndDate)='getEndDateValue($event)'>
              </EIPDateRangePicker>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="deD_Description"  ValueField="deD_Id" WaterMarkText="Select Structure / Package" [dataSource]='structurelist' [defaultValue]='' (valueChange)='selectedSturcture($event)' [IsCascading]='true'>
              </EIPAutoComplete>
          </div>
      </div>
      <div class="row eip-mt-10">
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 adv-srch-btns eip-ml-auto ">
              <button type="button" class="btn btn-primary eip-ml-20" (click)="viewReport()"><i class="fa fa-refresh" title="Load Report" aria-hidden="true"></i>&nbsp;&nbsp;Load Report</button>
              <button type="button" class="btn btn-secondary eip-ml-20" (click)="clearReport()"><i class="fa fa-cancel" title="Clear Filter" aria-hidden="true"></i>&nbsp;&nbsp;Clear Report</button>
          </div>
      </div>
  </form>
</div>
<div class="eip-pt-10 eip-pb-10">
  <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters" [parameters]="parameters" [language]="language" [width]="width" [height]="height" [toolbar]="toolbar">
  </ssrs-reportviewer>
</div>